















































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useUtilityStore } from "@/admin/store/utility";
import moment from "moment";

@Component({
  components: {
    Button,
    Input,
    ErrorSummary,
    GenericLoadingSpinner
  }
})
export default class HsabCpfBlackoutManagement extends Vue {
  $validator: Validator;
  moment = moment;
  utilityStore = useUtilityStore();
  isSubmitting = false;
  today = moment().format("YYYY-MM-DD");
  formDate = "";

  mounted () {
    this.utilityStore.getCpfBlackoutDates();
    this.$validator.extend("isTodayOrLater", this.isTodayOrLater);
    this.$validator.extend("isNewDate", this.isNewDate);
  }

  isTodayOrLater = {
    getMessage () {
      return "Blackout date cannot be in the past";
    },
    validate (date, args) {
      if (args[0] === "null") {
        return true;
      }
      return  moment(date).isSame(args[0]) || moment(date).isAfter(args[0]);
    }
  };

  isNewDate = {
    getMessage () {
      return "Blackout date already exists";
    },
    validate (date, args) {
      return !args.map(m => moment(m).format("YYYY-MM-DD")).includes(date);
    }
  };

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  onSubmit () {
    this.$validator.validateAll().then(valid => {
      if (valid) {
        this.isSubmitting = true;
        this.utilityStore.saveCpfBlackoutDate(this.formDate)
            .then(() => {
              this.formDate = "";
              this.$validator.reset();
              this.isSubmitting = false;
            });
      }
    });
  }
}

